<template>
  <popper trigger="hover" :options="{placement: 'bottom-end'}" append-to-body :visible-arrow="true" v-if="hasHooks">
    <div class="popper o-popover">
      <ul class="o-list o-list--menu">
        <li class="o-list__item o-list__item-with-button" :key="hookName" v-for="([hookName, hookLink]) in visibleHooks">
          <a :href="hookLink" target="_blank" class="o-list__link">
            <button class="c-button c-button--mini c-button--circle">
              <svg class="o-icon">
                <use v-bind="{'xlink:href':'#icon-'+ HOOK_ICONS[hookName]}"></use>
              </svg>
            </button>
            {{HOOK_LABELS[hookName]}}
          </a>
        </li>
      </ul>
    </div>
    <button slot="reference" class="o-playlist__button c-button--action" aria-label="Actions">
      <SvgIcon class="o-playlist__icon" icon="actions" />
    </button>
  </popper>
</template>

<script>
import Popper from 'vue-popperjs';

const HOOK_LABELS = {
  spotify: 'Open in Spotify',
  itunes: 'Open in Apple Music',
  youtube: 'Open in Youtube'
};

const HOOK_ICONS = {
  spotify: 'spotify',
  itunes: 'music',
  youtube: 'youtube',
};

export default {
  name: 'TrackActionSheet',
  components: {
    popper: Popper,
  },
  props: [
    'hooks',
  ],
  data() {
    return {
      HOOK_LABELS,
      HOOK_ICONS
    };
  },
  computed: {
    visibleHooks() {
      return Object.entries(this.hooks).filter(([type, link]) => link && type != 'm4a')
    },
    hasHooks() {
      return this.visibleHooks.length > 0
    }
  }
};
</script>
